
import { Component, Vue } from "vue-property-decorator";
import MasSitios from "@/components/Municipalidad/MasSitios.vue";

@Component({
  components: {
    MasSitios
  }
})
export default class MasSitiosView extends Vue {}
